import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import Textarea from "sushiweb/InputTypes/Textarea";
import Autocomplete from "@material-ui/lab/Autocomplete";
import TextField from "@material-ui/core/TextField";
import * as UserPropertyActions from "../../../store/actions/UserProperty";
import { getInitialState, isValNull } from "../../../utils";
import { filterObj } from "../../../utils";
import ChangeLogTableFields from "../../../constants/ChangeLogs/ChangeLogTableFields.json";
import ChangeLogList from "../../Common/ChangeLogList";
import Permission from "../../Common/Permission";
import MenuNames from "../../../constants/Menu/MenuNames.json";
import MenuActionsMappings from "../../../constants/Menu/MenuActionsMappings";
import NoFooterModal from "../../Common/NoFooterModal";
import Input from "sushiweb/InputTypes/Input";
import { BottomSectionModal } from "../../../constants/assets/containers";
import Button from "sushiweb/Button";
import variables from "../../../constants/assets/variables";
const disabledFieldsInEditState = ["user_id", "key"];

export const PropertiesFormModal = (props) => {
  const {
    modalState,
    handleClose,
    activeId,
    activeUserProperty,
    activeFilters,
    keysList,
  } = props;
  const allActions = MenuActionsMappings[MenuNames.USER_PROPERTY];
  const [initialState, setInitialState] = useState({
    user_id: "",
    key: "",
    value: "",
  });

  const handleSubmit = (e) => {
    e.preventDefault();

    const body = filterObj(initialState, ["user_id", "key", "value"]);
    if (body.user_id) {
      body.user_id = parseInt(body.user_id);
    }
    if (modalState === "Filter") {
      let filters = {
        ...body,
      };
      props.getUserPropertyList(filters).then((res) => {
        handleClose();
      });
    } else if (modalState === "Add") {
      props.createUserProperty(body);
    } else if (modalState === "Edit") {
      props.updateUserProperty(body);
    }
  };

  const handleClearFilters = () => {
    props.getUserPropertyList({}).then((res) => {
      props.resetState({ state: "activeFilters" });
      handleClose();
    });
  };

  const handleChange = (key, val) => {
    let values = { ...initialState };
    values[key] = val;
    setInitialState(values);
  };

  const checkIfDisabled = (key) => {
    if (activeUserProperty["isDeleted"]) {
      return true;
    }
    if (modalState === "Edit") {
      return disabledFieldsInEditState.includes(key) ? true : false;
    } else {
      return false;
    }
  };

  const getRequiredButtonPerms = (action = undefined) => {
    if (action !== undefined) {
      if (action === "DELETE") {
        return [allActions.DELETE];
      }
    }

    if (modalState === "Edit") {
      return [allActions.UPDATE];
    } else if (modalState === "Add") {
      return [allActions.CREATE];
    }
    return undefined;
  };

  useEffect(() => {
    if (activeId) {
      props.getUserProperty(activeId);
    }
  }, [activeId, modalState]);

  useEffect(() => {
    //set the initial state of form in modal
    if (activeUserProperty && modalState === "Edit") {
      let values = { ...initialState };
      Object.keys(values).map((key, idx) => {
        values[key] = activeUserProperty[key]
          ? activeUserProperty[key]
          : getInitialState(initialState, key);
      });
      setInitialState(values);
    }
    if (activeFilters && modalState === "Filter") {
      let values = { ...initialState };
      Object.keys(values).map((key, idx) => {
        values[key] = activeFilters[key] ? activeFilters[key] : "";
      });
      setInitialState(values);
    }
  }, [activeUserProperty, activeFilters]);

  const getModalButtons = () => {
    if (modalState === "Edit" && activeUserProperty["isDeleted"]) {
      return "";
    }

    return (
      <BottomSectionModal className="flex items-center justify-between">
        {modalState === "Filter" && (
          <Button
            data-testid="filterFeatureBtn"
            onClick={handleClearFilters}
            className="sushi-btn"
          >
            Clear
          </Button>
        )}
        <Permission requiredPerms={getRequiredButtonPerms()}>
          <Button
            data-testid="submitButton"
            className="sushi-btn"
            onClick={handleSubmit}
          >
            {modalState === "Filter" ? "Apply" : "Submit"}
          </Button>
        </Permission>
      </BottomSectionModal>
    );
  };

  return (
    <>
      <NoFooterModal
        header={true}
        heading={`${modalState} User Property`}
        handleClose={handleClose}
        id="PropertiesFormModal"
        modalButtons={getModalButtons()}
      >
        <Input
          value={initialState.user_id}
          data-testid="userId"
          id="sushi-input"
          disabled={checkIfDisabled("user_id")}
          onChange={(e) => handleChange("user_id", e)}
          label="User ID"
        />
        <Autocomplete
          value={initialState.key}
          onChange={(event, newValue) => {
            handleChange("key", newValue);
          }}
          disabled={checkIfDisabled("key")}
          closeIcon={false}
          id="key-list"
          options={keysList}
          style={{ width: 300 }}
          renderInput={(params) => (
            <TextField {...params} label="Key" variant="outlined" />
          )}
        />

        {(modalState === "Edit" || modalState === "Add") && (
          <Textarea
            id="sushi-textarea"
            data-testid="value"
            borderColor={variables.primaryColor}
            innerWidth="100%"
            className="mb-20"
            resize="none"
            label="Value"
            disabled={false}
            onChange={(e) => handleChange("value", e)}
            value={initialState.value}
          />
        )}

        {modalState === "Edit" && (
          <ChangeLogList
            changes={initialState.changes}
            tableFields={ChangeLogTableFields}
          />
        )}
      </NoFooterModal>
    </>
  );
};

function mapStateToProps(state) {
  const { UserProperty } = state;
  return {
    activeUserProperty: UserProperty.activeUserProperty,
    activeFilters: UserProperty.activeFilters,
    currentPage: UserProperty.currentPage,
    keysList: UserProperty.keysList,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    createUserProperty: bindActionCreators(
      UserPropertyActions.createUserProperty,
      dispatch
    ),
    getUserPropertyList: bindActionCreators(
      UserPropertyActions.getUserPropertyList,
      dispatch
    ),
    getUserProperty: bindActionCreators(
      UserPropertyActions.getUserProperty,
      dispatch
    ),
    getKeys: bindActionCreators(
      UserPropertyActions.getUserPropertyKeys,
      dispatch
    ),
    updateUserProperty: bindActionCreators(
      UserPropertyActions.updateUserProperty,
      dispatch
    ),
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PropertiesFormModal);
